export default __webpack_public_path__ + "static/media/Water.7c4b2f9e.png";